// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-slideshow-container button {
    display: none;
}

.react-slideshow-fadezoom-images-wrap > div {
    position: absolute;
    top: 0;
    left: auto !important;
}

div.react-slideshow-container > div > div > div > div, div.each-fade {
    object-fit: cover;
    transform: translateX(0);
    transition: transform 1s ease;
    height: 100vh;
    width: 100vw;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center center;
    background-attachment: fixed;
}

.react-slideshow-wrapper > div {
    height: 100vh;
    width: max-content !important;
}
.react-slideshow-wrapper > div > div {
    width: 100vw;
}

.react-slideshow-wrapper > div > div {
    display: inline-block !important;
}

`, "",{"version":3,"sources":["webpack://./src/css/slider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".react-slideshow-container button {\n    display: none;\n}\n\n.react-slideshow-fadezoom-images-wrap > div {\n    position: absolute;\n    top: 0;\n    left: auto !important;\n}\n\ndiv.react-slideshow-container > div > div > div > div, div.each-fade {\n    object-fit: cover;\n    transform: translateX(0);\n    transition: transform 1s ease;\n    height: 100vh;\n    width: 100vw;\n    background-repeat: no-repeat;\n    background-size: 100% auto;\n    background-position: center center;\n    background-attachment: fixed;\n}\n\n.react-slideshow-wrapper > div {\n    height: 100vh;\n    width: max-content !important;\n}\n.react-slideshow-wrapper > div > div {\n    width: 100vw;\n}\n\n.react-slideshow-wrapper > div > div {\n    display: inline-block !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
